// Option Two (/service-entry-optionTwo): the full description is shown on every card.
import React from "react";
import { NO_DESCRIPTION, useServiceColumns } from "./serviceData";
import { ServiceEntryShell, ServiceTile } from "./shared";

export default function ServiceEntryOptionTwo() {
  const columns = useServiceColumns();

  return (
    <ServiceEntryShell variant="b">
      <div className="service-entry-columns">
        {columns.map((column) => (
          <section className="service-entry-column" key={column.title}>
            <h2>{column.title}</h2>
            <div className="service-entry-list">
              {column.items.map((item) => (
                <ServiceTile item={item} key={item.label}>
                  <span className="se-card-desc">{item.description || NO_DESCRIPTION}</span>
                </ServiceTile>
              ))}
            </div>
          </section>
        ))}
      </div>
    </ServiceEntryShell>
  );
}
